var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, "enforce-focus": false },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modal_id,
            title: "売掛",
            size: "xl",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
            scrollable: "",
          },
          on: { hide: _vm.closeModal },
        },
        [
          _c(
            "div",
            {
              staticClass: "main_modal_div",
              staticStyle: { "min-height": "500px" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { "margin-bottom": "5px" },
                },
                [
                  _c(
                    "b-form-select",
                    {
                      staticStyle: { width: "100px" },
                      on: { change: _vm.onDateChange },
                      model: {
                        value: _vm.on_type,
                        callback: function ($$v) {
                          _vm.on_type = $$v
                        },
                        expression: "on_type",
                      },
                    },
                    _vm._l(_vm.sel_on_type, function (option) {
                      return _c(
                        "option",
                        { key: option.id, domProps: { value: option.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(option.text) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("v-date-picker", {
                    staticClass: "date_picker",
                    attrs: { "is-required": "" },
                    on: { input: _vm.onDateChange },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ inputValue, inputEvents }) {
                          return [
                            _c(
                              "b-input",
                              _vm._g(
                                { attrs: { value: inputValue, readonly: "" } },
                                inputEvents
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.date1,
                      callback: function ($$v) {
                        _vm.date1 = $$v
                      },
                      expression: "date1",
                    },
                  }),
                  _vm._v("\n         - \n        "),
                  _c("v-date-picker", {
                    staticClass: "date_picker",
                    attrs: { "is-required": "" },
                    on: { input: _vm.onDateChange },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ inputValue, inputEvents }) {
                          return [
                            _c(
                              "b-input",
                              _vm._g(
                                { attrs: { value: inputValue, readonly: "" } },
                                inputEvents
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.date2,
                      callback: function ($$v) {
                        _vm.date2 = $$v
                      },
                      expression: "date2",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { width: "1200px" } },
                [
                  _c("b-table-filter-pager", {
                    attrs: {
                      busy: _vm.busy,
                      maxHeight: _vm.maxHeight,
                      filter_list: _vm.filter_list,
                      filter_val: _vm.filter_val,
                      filter_val_ex: _vm.filter_val_ex,
                      data_list_field: _vm.data_list_field,
                      data_list: _vm.data_list,
                      data_count: _vm.data_count,
                      currentPage: _vm.current_page,
                      filter_enable: true,
                      nav_flg: true,
                      add_btn: false,
                      edit_disabled: _vm.pms_nyukin < 2,
                    },
                    on: {
                      on_sort: _vm.onSort,
                      on_page_change: _vm.onPageChange,
                      on_edit: _vm.modalShow,
                      on_filter_ex: _vm.onFilterEx,
                      on_nyukin_chk: _vm.onNyukinChk,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: {
                    width: "1200px",
                    "margin-top": "0px",
                    "margin-left": "-10px",
                  },
                },
                [
                  _c(
                    "label",
                    { staticStyle: { "margin-left": "15px", float: "right" } },
                    [_vm._v("入金合計")]
                  ),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "140px", "text-align": "right" },
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.sum_nyukin_price,
                      callback: function ($$v) {
                        _vm.sum_nyukin_price = $$v
                      },
                      expression: "sum_nyukin_price",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v("手数料合計"),
                  ]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "110px", "text-align": "right" },
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.sum_commission,
                      callback: function ($$v) {
                        _vm.sum_commission = $$v
                      },
                      expression: "sum_commission",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v("差額合計"),
                  ]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "110px", "text-align": "right" },
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.sum_difference,
                      callback: function ($$v) {
                        _vm.sum_difference = $$v
                      },
                      expression: "sum_difference",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v("請求額合計"),
                  ]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "140px", "text-align": "right" },
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.sum_price,
                      callback: function ($$v) {
                        _vm.sum_price = $$v
                      },
                      expression: "sum_price",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "margin-left": "10px" } }, [
                    _vm._v("未処理合計"),
                  ]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "140px", "text-align": "right" },
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.sum_un_price,
                      callback: function ($$v) {
                        _vm.sum_un_price = $$v
                      },
                      expression: "sum_un_price",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-nyukin",
                title: "売掛 > 編集",
                "header-bg-variant": "dark",
                "header-text-variant": "light",
                "body-bg-variant": "light",
                "hide-footer": "",
                centered: "",
              },
            },
            [
              _c("div", { staticClass: "modal_div" }, [
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", { staticClass: "block_label" }, [
                      _vm._v("伝票番号"),
                    ]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "150px" },
                      attrs: { type: "text", disabled: "" },
                      model: {
                        value: _vm.nyukin.m_code_ex,
                        callback: function ($$v) {
                          _vm.$set(_vm.nyukin, "m_code_ex", $$v)
                        },
                        expression: "nyukin.m_code_ex",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", { staticClass: "block_label" }, [
                      _vm._v("品題"),
                    ]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "200px" },
                      attrs: { type: "text", disabled: "" },
                      model: {
                        value: _vm.nyukin.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.nyukin, "title", $$v)
                        },
                        expression: "nyukin.title",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", { staticClass: "block_label" }, [
                      _vm._v("顧客"),
                    ]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "300px" },
                      attrs: { type: "text", disabled: "" },
                      model: {
                        value: _vm.nyukin.client_company,
                        callback: function ($$v) {
                          _vm.$set(_vm.nyukin, "client_company", $$v)
                        },
                        expression: "nyukin.client_company",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", { staticClass: "block_label" }, [
                      _vm._v("入金日"),
                    ]),
                    _vm._v(" "),
                    _c("v-date-picker", {
                      staticClass: "date_picker",
                      attrs: { "is-required": "" },
                      on: { input: _vm.onNyukinOnChange },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c(
                                "b-input",
                                _vm._g(
                                  {
                                    attrs: { value: inputValue, readonly: "" },
                                  },
                                  inputEvents
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.nyukin.nyukin_on,
                        callback: function ($$v) {
                          _vm.$set(_vm.nyukin, "nyukin_on", $$v)
                        },
                        expression: "nyukin.nyukin_on",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", { staticClass: "block_label" }, [
                      _vm._v("請求額"),
                    ]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "150px", "text-align": "right" },
                      attrs: { type: "number", disabled: "" },
                      model: {
                        value: _vm.nyukin.price,
                        callback: function ($$v) {
                          _vm.$set(_vm.nyukin, "price", $$v)
                        },
                        expression: "nyukin.price",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", { staticClass: "block_label" }, [
                      _vm._v("入金"),
                    ]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "150px", "text-align": "right" },
                      attrs: { type: "number" },
                      on: {
                        change: function ($event) {
                          return _vm.onNyukinChange("nyukin_price")
                        },
                      },
                      model: {
                        value: _vm.nyukin.nyukin_price,
                        callback: function ($$v) {
                          _vm.$set(_vm.nyukin, "nyukin_price", $$v)
                        },
                        expression: "nyukin.nyukin_price",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", { staticClass: "block_label" }, [
                      _vm._v("手数料"),
                    ]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "150px", "text-align": "right" },
                      attrs: { type: "number" },
                      on: {
                        change: function ($event) {
                          return _vm.onNyukinChange("commission")
                        },
                      },
                      model: {
                        value: _vm.nyukin.commission,
                        callback: function ($$v) {
                          _vm.$set(_vm.nyukin, "commission", $$v)
                        },
                        expression: "nyukin.commission",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", { staticClass: "block_label" }, [
                      _vm._v("差額"),
                    ]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "150px", "text-align": "right" },
                      attrs: { type: "number", disabled: "" },
                      model: {
                        value: _vm.nyukin.difference,
                        callback: function ($$v) {
                          _vm.$set(_vm.nyukin, "difference", $$v)
                        },
                        expression: "nyukin.difference",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", { staticClass: "block_label" }, [
                      _vm._v("摘要"),
                    ]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "300px" },
                      attrs: { type: "text" },
                      model: {
                        value: _vm.nyukin.note,
                        callback: function ($$v) {
                          _vm.$set(_vm.nyukin, "note", $$v)
                        },
                        expression: "nyukin.note",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _c(
                    "b-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.hide("modal-nyukin")
                        },
                      },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "x" } }),
                      _vm._v("取消\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.updateNyukin },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 保存\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }